import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createSpreadProfileEpic } from './_epics/createSpreadProfile.epic';
import { loadSpreadProfileListEpic } from './_epics/loadSpreadProfileList.epic';
import { removeSpreadProfileEpic } from './_epics/removeSpreadProfile.epic';
import { updateSpreadProfileEpic } from './_epics/updateSpreadProfile.epic';

export const spreadProfileEpic = safeCombineEpics(
  createSpreadProfileEpic,
  loadSpreadProfileListEpic,
  removeSpreadProfileEpic,
  updateSpreadProfileEpic,
);
